import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../../api.base';
import { PolicyRawInfo } from './api.policy.common';

export interface IGetPolicyUsagePathParameter {
    devicePolicyID: string;
}


export class APIGetPolicyUsageManager extends APIBaseManager<IGetPolicyUsagePathParameter, void, void, PolicyRawInfo> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_GetPolicyUsage';
        this._apiMethod = 'GET';
    }

    protected getRequestURL(pathParameters: IGetPolicyUsagePathParameter, queryParameters: void): string {
        return super.getRequestURL() + 'devicePolicies/' + pathParameters.devicePolicyID + '/usage';
    }
}